<div class="flex items-center mb-1" mat-dialog-title style="margin-bottom: 15px">
	<p fxFlex class="flex-auto text-lg font-medium" class="dragHandle" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
		{{ data.title | translate }}
	</p>
	<button mat-dialog-close mat-icon-button type="button">
		<mat-icon size="24px">close</mat-icon>
	</button>
</div>
<div mat-dialog-content>
	<p *ngIf="data.lable">{{ data.lable | translate }}</p>
	<span *ngIf="data.info">{{ data.info }}</span>
</div>
<div mat-dialog-actions>
	<span class="flex-1"></span>
	<button mat-flat-button color="primary" (click)="closePopup(true)">{{ data.buttonTextYes | translate }}</button>
	<button mat-flat-button (click)="closePopup(false)">{{ data.buttonTextNo | translate }}</button>
</div>
